import { Box, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

interface StatCardProps {
    title: string;
    children: ReactNode;
}

const StatCard = ({ title, children }: StatCardProps) => {
    return (
        <Paper style={{ width: "100%", height: "100%" }}>
            <Box padding={2} textAlign="center">
                <Typography sx={{ fontSize: "1rem" }}>
                    {title}
                </Typography>
                {children}
            </Box>
        </Paper>
    );
};

export default StatCard;